// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#links {
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
}
#links.no-modal {
    justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Coordinator/Links.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,8BAA8B;AAClC","sourcesContent":["#links {\n    margin-top: 20px;\n    display: flex;\n    justify-content: space-around;\n}\n#links.no-modal {\n    justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
